import Swiper, { Lazy, Autoplay, Navigation, Pagination } from 'swiper';


export default class ProjectImages {

	constructor () {
		this.init();
	}

	init () {
		if(document.querySelectorAll('.project-images')) {
			Swiper.use([Navigation, Pagination, Lazy]);
			new Swiper('.project-images', {
				slidesPerView: 1,
				slidesPerColumn: 1,
				slidesPerGroup: 1,
				preloadImages: false,
				spaceBetween: 0,
				pagination: {
				  el: '.project-images .swiper-pagination',
				  clickable: true
				},
				navigation: {
				  nextEl: '.project-images-next',
				  prevEl: '.project-images-prev'
				},
				lazy: {
					loadPrevNext: false,
					loadOnTransitionStart: true,
				},
				on: {
				  init: function (swiper) {
				  }
				}
			  });
		}
	}
}
